import { BdaService } from "../models/BdaService";
import { PagedResults } from "../models/generics";
import client from "./axios";

const servicesUrl = `${window.__env.GATEWAY_URL}/v1/services`;

export const Services = {
  getServices: (params?: URLSearchParams) => client.get<PagedResults<BdaService> | Array<BdaService>>(servicesUrl, { params }),
  getService: (id: number, params?: URLSearchParams) => client.get<BdaService>(`${servicesUrl}/${id}`, { params }),
  createService: (service: BdaService, params?: URLSearchParams) => client.post<BdaService>(servicesUrl, service, { params }),
  getServiceMarkDown: (id: number) => client.get<string>(`${servicesUrl}/${id}/markdown`),
  updateService: (service: BdaService, params?: URLSearchParams) => client.put<BdaService>(`${servicesUrl}/${service.id}`, service, { params }),
  updateServiceFields: (service: BdaService, params?: URLSearchParams) => client.patch<BdaService>(`${servicesUrl}/${service.id}`, service, { params }),
  deleteService: (id: number, params?: URLSearchParams) => client.delete(`${servicesUrl}/${id}`, { params }),
  getModes: (params?: URLSearchParams) => client.get<string[]>(`${servicesUrl}/modes`, { params }),
  getAreas: (params?: URLSearchParams) => client.get<string[]>(`${servicesUrl}/areas`, { params }),
  createServiceMarkdown: (id: number, markdown: { value: string }) => client.post(`${servicesUrl}/${id}/markdown`, markdown),
  updateServiceMarkdown: (id: number, markdown: { value: string }) => client.put(`${servicesUrl}/${id}/markdown`, markdown),
  validateMarkdown: (body: any) => client.post(`${window.__env.EVENT_GATEWAY_URL}/markdown/check`, body),
}